import React, {useState, useEffect} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Link, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CarIcon from '@mui/icons-material/DirectionsCar';
import ExitIcon from '@mui/icons-material/ExitToApp';
import OfferIcon from '@mui/icons-material/LocalOffer';
import NotifyIcon from '@mui/icons-material/NotificationsActive';
import { api } from 'common';
import { colors } from '../components/Theme/WebTheme';
import { useTranslation } from "react-i18next";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ViewListIcon from '@mui/icons-material/ViewList';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import AssessmentIcon from '@mui/icons-material/Assessment';
import MoneyIcon from '@mui/icons-material/Money';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SettingsIcon from '@mui/icons-material/Settings';
import SosIcon from '@mui/icons-material/Sos';
import {WEB_MAIN_COLOR, WEB_SECONDORY_COLOR, FONT_FAMILY} from "../common/sharedFunctions"
import AnnouncementOutlinedIcon from '@mui/icons-material/AnnouncementOutlined';
import BuildIcon from '@mui/icons-material/Build';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import CampaignIcon from '@mui/icons-material/Campaign';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { usePanelDark, setPanelDark, PANEL_DARK_BG } from '../common/panelTheme';

const drawerWidth = 260;

export default function ResponsiveDrawer(props) {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const {
    signOff
  } = api;
  const auth = useSelector(state => state.auth);
  const settings = useSelector(state => state.settingsdata.settings);
  const dispatch = useDispatch();
  const MAIN_COLOR = WEB_MAIN_COLOR(settings?.appCat);
  const SECONDORY_COLOR = WEB_SECONDORY_COLOR(settings?.appCat);

  const LogOut = () => {
    dispatch(signOff());
  };

  const [role, setRole] = useState(null);

  useEffect(() => {
    if(auth.profile && auth.profile.usertype){
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const handleDrawer = () => {
    setMobileOpen(false);
  };

  const location = useLocation();
  const [query, setQuery] = useState('');
  const dark = usePanelDark();

  const seg = (p) => '/' + (p || '').split('/').filter(Boolean)[0];
  const isActive = (url) => {
    if (!url || url === 'logout') return false;
    if (url === '/') return location.pathname === '/';
    return seg(location.pathname) === seg(url);
  };

  const menuGroups = [
    {
      label: t('group_operation', { defaultValue: 'Operación' }),
      items: [
        { name: t('home'), url: '/', icon: <HomeIcon />, access: ['admin','fleetadmin','driver','customer'] },
        { name: t('dashboard_text'), url: '/dashboard', icon: <DashboardIcon />, access: ['admin','fleetadmin'] },
        { name: t('booking_history'), url: '/bookings', icon: <ViewListIcon />, access: ['admin','fleetadmin','driver','customer'] },
        { name: t('tab_launches', { defaultValue: 'Lanzamientos' }), url: '/launches', icon: <RocketLaunchIcon />, access: ['admin','fleetadmin','driver','customer'] },
        { name: t('addbookinglable'), url: '/addbookings', icon: <ContactPhoneIcon />, access: settings && settings.appCat === 'bidcab' ? ['customer'] : ['admin','fleetadmin','customer'] },
        { name: t('user'), url: '/users/0', icon: <EmojiPeopleIcon />, access: ['admin','fleetadmin'] },
        { name: t('cars'), url: '/cars', icon: <CarIcon />, access: ['admin','fleetadmin','driver'] },
        { name: t('workshops_menu', { defaultValue: 'Talleres' }), url: '/workshops', icon: <BuildIcon />, access: ['admin','fleetadmin'] },
        { name: t('sos'), url: '/sos', icon: <SosIcon />, access: ['admin'] },
        { name: t('complain'), url: '/complain', icon: <AnnouncementOutlinedIcon />, access: ['admin'] },
        { name: t('user_reports_menu', { defaultValue: 'Denuncias' }), url: '/user-reports', icon: <ReportProblemOutlinedIcon />, access: ['admin'] },
      ],
    },
    {
      label: t('group_catalog', { defaultValue: 'Catálogo' }),
      items: [
        { name: t('car_type'), url: '/cartypes', icon: <CarIcon />, access: ['admin'] },
      ],
    },
    {
      label: t('group_finance', { defaultValue: 'Finanzas' }),
      items: [
        { name: t('withdraws_web'), url: '/withdraws', icon: <MoneyIcon />, access: ['admin'] },
        { name: t('admin_driver_wallet_title', { defaultValue: 'Recargar billetera del conductor' }), url: '/addtowallet', icon: <AccountBalanceWalletIcon />, access: ['admin'] },
        { name: t('report'), url: '/allreports', icon: <AssessmentIcon />, access: ['admin','fleetadmin'] },
        { name: t('my_wallet_tile'), url: '/userwallet', icon: <AccountBalanceWalletIcon />, access: ['driver','customer','fleetadmin'] },
      ],
    },
    {
      label: t('group_growth', { defaultValue: 'Crecimiento' }),
      items: [
        { name: t('b2b_partners', { defaultValue: 'Empresas B2B' }), url: '/b2b', icon: <BusinessIcon />, access: ['admin'] },
        { name: t('advertisers_menu', { defaultValue: 'Impulso' }), url: '/advertisers', icon: <CampaignIcon />, access: ['admin'] },
        { name: t('promo'), url: '/promos', icon: <OfferIcon />, access: ['admin'] },
        { name: t('push_notifications'), url: '/notifications', icon: <NotifyIcon />, access: ['admin'] },
      ],
    },
    {
      label: t('group_config', { defaultValue: 'Configuración' }),
      items: [
        { name: t('settings_title'), url: '/settings', icon: <SettingsIcon />, access: ['admin'] },
        { name: t('payment_settings'), url: '/paymentsettings', icon: <PhoneIphoneIcon />, access: ['admin'] },
      ],
    },
    {
      label: t('group_account', { defaultValue: 'Cuenta' }),
      items: [
        { name: t('profile'), url: '/profile', icon: <AccountCircleIcon />, access: ['admin','fleetadmin','driver','customer'] },
        { name: t('logout'), url: 'logout', icon: <ExitIcon />, access: ['admin','fleetadmin','driver','customer'] },
      ],
    },
  ];

  const q = query.trim().toLowerCase();
  const matches = (item) => item.access.includes(role) && (!q || (item.name || '').toLowerCase().indexOf(q) !== -1);

  const renderItem = (item, index) => {
    const active = isActive(item.url);
    const accent = active ? colors.GREEN : colors.Header_Text;
    return (
      <ListItem key={item.url + index} disableGutters disablePadding style={{ paddingLeft: 0 }} alignItems="center" onClick={handleDrawer}>
        <ListItemButton
          selected={active}
          component={Link}
          to={item.url === 'logout' ? null : item.url}
          onClick={item.url === 'logout' ? LogOut : null}
          sx={{
            py: 1.1,
            borderLeft: active ? `4px solid ${colors.GREEN}` : '4px solid transparent',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.14)' },
            '&.Mui-selected, &.Mui-selected:hover': { backgroundColor: 'rgba(255,255,255,0.16)' },
            '&.Mui-focusVisible, &:focus, &:active': { backgroundColor: 'rgba(255,255,255,0.14)' },
            '& .MuiTouchRipple-root': { color: 'rgba(255,255,255,0.35)' },
          }}
        >
          <ListItemIcon style={{ color: accent, minWidth: 42 }}>
            {item.icon}
          </ListItemIcon>
          <ListItemText
            primary={<Typography style={{ color: accent, textAlign: isRTL === 'rtl' ? 'right' : 'left', fontFamily: FONT_FAMILY, fontWeight: active ? 700 : 400 }}>
              {item.name}
            </Typography>}
          />
        </ListItemButton>
      </ListItem>
    );
  };

  const drawer = (
    <div style={{ backgroundColor: MAIN_COLOR, height: '100%' }}>
      <div style={{ display: 'flex', backgroundColor: 'transparent', justifyContent: 'center' }}>
        <img style={{ marginTop: '24px', marginBottom: '16px', width: '150px', height: 'auto' }} src={require("../assets/img/logo138x75white.png")} alt="Logo Movex" />
      </div>
      {role ?
        <Box sx={{ px: 1.5, pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, backgroundColor: 'rgba(255,255,255,0.12)', borderRadius: '10px', px: 1.2, py: 0.5 }}>
            <SearchIcon style={{ color: 'rgba(255,255,255,0.7)', fontSize: 20 }} />
            <InputBase
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder={t('search_menu_placeholder', { defaultValue: 'Buscar en el menú...' })}
              sx={{ color: '#fff', fontFamily: FONT_FAMILY, fontSize: 14, flex: 1, '& input::placeholder': { color: 'rgba(255,255,255,0.6)', opacity: 1 } }}
            />
          </Box>
        </Box>
        : null}
      <div style={{ backgroundColor: 'transparent', paddingBottom: 24 }}>
        {role ?
          menuGroups.map((group, gi) => {
            const visible = group.items.filter(matches);
            if (visible.length === 0) return null;
            return (
              <List
                key={'group' + gi}
                disablePadding
                subheader={
                  <ListSubheader
                    disableSticky
                    component="div"
                    style={{ backgroundColor: 'transparent', color: 'rgba(255,255,255,0.5)', fontFamily: FONT_FAMILY, fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', lineHeight: '32px', textAlign: isRTL === 'rtl' ? 'right' : 'left' }}
                  >
                    {group.label}
                  </ListSubheader>
                }
              >
                {visible.map((item, index) => renderItem(item, index))}
              </List>
            );
          })
          : null}
      </div>
    </div>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex',direction:isRTL === 'rtl'? 'rtl':'ltr'}}>
      <CssBaseline />
      <style>
        {`
          ::-webkit-scrollbar {
            width: 8px;
          }

          ::-webkit-scrollbar-thumb {
            background-color: ${SECONDORY_COLOR};
            border-radius: 6px;
          }

          ::-webkit-scrollbar-thumb:hover {
            background-color: ${MAIN_COLOR};
          }

          ::-webkit-scrollbar-track {
            background-color:${colors.WHITE};
          }
        `}
      </style>
      <AppBar
        position="fixed"
        style={isRTL=== 'rtl'? {marginRight:drawerWidth,backgroundColor:MAIN_COLOR,}:{marginLeft:drawerWidth,backgroundColor:MAIN_COLOR,}}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color={colors.WHITE}
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2,  display: { sm: 'none' }, }}
          >
            <MenuIcon style={{color:colors.WHITE}} />
          </IconButton>
          <Typography variant="h6" noWrap component="div" style={{color:colors.WHITE, fontFamily:FONT_FAMILY, flexGrow: 1}}>
          {settings && settings.appName? settings.appName: '' }
          </Typography>
          <IconButton
            onClick={() => setPanelDark(!dark)}
            aria-label="toggle dark mode"
            title={dark ? t('light_mode', { defaultValue: 'Modo claro' }) : t('dark_mode', { defaultValue: 'Modo oscuro' })}
            style={{ color: colors.WHITE }}
          >
            {dark ? <Brightness7Icon /> : <Brightness4Icon />}
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          container={container}
          variant="temporary"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: MAIN_COLOR, borderRight: 'none' },direction:isRTL === 'rtl'? 'rtl':'ltr'
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          anchor={isRTL === 'rtl' ? 'right' : 'left'}
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: MAIN_COLOR, borderRight: 'none' },direction:isRTL === 'rtl'? 'rtl':'ltr'
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          minHeight: '100vh',
          backgroundColor: dark ? PANEL_DARK_BG : '#F4F6FA',
          transition: 'background-color 0.2s ease',
        }}
      >
        <Toolbar/>
        {props.children}
      </Box>
    </Box>
  );
}
